import { CountryNames, Locales } from '../enums/general'

export default {
  /**
   * Default Country
   */
  defaultCountry: 'nl',

  /**
   * All supported countries
   */
  countries: Object.keys(CountryNames),

  /**
   * Default Locale
   */
  defaultLocale: 'en',

  /**
   * All supported locales
   */
  locales: Object.keys(Locales)

}
